export const LoadingPage = 'LoadingPage';
export const RootOnboarding = 'RootOnboarding';
export const EmailVerification = 'EmailVerification';
export const AthleteTeamInvitationDecline = 'AthleteTeamInvitationDecline';
export const NoInvitation = 'NoInvitation';
export const ViewEvaluation = 'ViewEvaluation';
export const StudentViewEvaluation = 'StudentViewEvaluation';
export const DemoDiscussion = 'DemoDiscussion';
export const DemoSSE = 'DemoSSE';
export const DemoAthleteSearch = 'DemoAthleteSearch';
export const DemoImageCache = 'DemoImageCache';
export const DemoComponents = 'DemoComponents';
export const UIComponentDocumentation = 'UIComponentDocumentation';
export const NotFound = 'NotFound';
export const Unauthorized = 'Unauthorized';

export const ProfileManagement = 'ProfileManagement';
export const AthleteProfilesManagement = 'AthleteProfilesManagement';
export const UpgradeSubscriptionPage = 'UpgradeSubscriptionPage';

export const AthleteProfileSetup = 'AthleteProfileSetup';
export const AthleteProfile = 'AthleteProfile';
export const AthleteRecruitingProfileView = 'AthleteRecruitingProfileView';
export const AthleteSharingSummary = 'AthleteSharingSummary';
export const AthleteRecruitingProfileEdit = 'AthleteRecruitingProfileEdit';
export const AthleteProfileMetric = 'AthleteProfileMetric';
export const AthleteComparativeData = 'AthleteComparativeData';
export const AthleteComparativeDataSummary = 'AthleteComparativeDataSummary';
export const AthleteComparativeDataCompare = 'AthleteComparativeDataCompare';
export const AthleteComparativeDataMyProgress = 'AthleteComparativeDataMyProgress';
export const AthleteComparativeDataPerformanceSummary = 'AthleteComparativeDataPerformanceSummary';
export const AthleteMindsetReport = 'AthleteMindsetReport';
export const AthleteScoutingReportsView = 'AthleteScoutingReportsView';
export const AthleteVerifiedAssessmentSummary = 'AthleteVerifiedAssessmentSummary';
export const AthleteSchoolSearch = 'AthleteSchoolSearch';
export const AthleteSelfReportSummary = 'AthleteSelfReportSummary';
export const AthleteSelfAssessmentForm = 'AthleteSelfAssessmentForm';
export const AthleteSelfAssessmentIntro = 'AthleteSelfAssessmentIntro';
export const AccountSettingsPersonalInfo = 'AccountSettingsPersonalInfo';
export const AccountSettingsProfilePicture = 'AccountSettingsProfilePicture';
export const AccountSettingsChangePassword = 'AccountSettingsChangePassword';
export const AthleteSettingsAccessControlForm = 'AthleteSettingsAccessControlForm';
export const AthleteSettingsPaymentForm = 'AthleteSettingsPaymentForm';
export const AthleteSettingsSubscriptionForm = 'AthleteSettingsSubscriptionForm';
export const AthleteSelfReport = 'AthleteSelfReport';
export const AthleteTeamJoin = 'AthleteTeamJoin';
export const AthleteClaimAssessmentForm = 'AthleteClaimAssessmentForm';
export const AthleteClaimSPQAssessmentForm = 'AthleteClaimSPQAssessmentForm';
export const AthleteClaimScoutingReportForm = 'ClaimScoutingReportForm';
export const AthleteVideoStudio = 'AthleteVideoStudio';
export const AthleteCheckoutPage = 'AthleteCheckoutPage';
export const AthleteScoutingReport = 'AthleteScoutingReport';

export const CoachProfileSetup = 'CoachProfileSetup';
export const CoachDashboard = 'CoachDashboard';
export const CoachViewAthlete = 'CoachViewAthlete';
export const CoachViewAthleteVideos = 'CoachViewAthleteVideos';
export const TeamDashboard = 'TeamDashboard';
export const TeamDashboardCalendar = 'TeamDashboardCalendar';
export const TeamDashboardRoster = 'TeamDashboardRoster';
export const TeamDashboardDepthCharts = 'TeamDashboardDepthCharts';
export const TeamDashboardGames = 'TeamDashboardGames';
export const AthleteTeamDashboardCalendar = 'AthleteTeamDashboardCalendar';
export const AthleteTeamDashboardRoster = 'AthleteTeamDashboardRoster';
export const AthleteTeamDashboardGames = 'AthleteTeamDashboardGames';
export const FullScreenCalendar = 'FullScreenCalendar';
export const AthleteTeamDashboard = 'AthleteTeamDashboard';
export const AthleteTeamEventView = 'AthleteTeamEventView';
export const TeamEventCreate = 'TeamEventCreate';
export const TeamEventEdit = 'TeamEventEdit';
export const TeamEventView = 'TeamEventView';
export const CoachProfile = 'CoachProfile';
export const AthleteSearch = 'AthleteSearch';
export const TeamCreate = 'TeamCreate';
export const TeamJoin = 'TeamJoin';
export const EditTeam = 'EditTeam';
export const CoachCreateResume = 'CoachCreateResume';
export const CoachEditResume = 'CoachEditResume';
export const CoachRecruitingSummary = 'CoachRecruitingSummary';
export const CoachScoutingSummary = 'CoachScoutingSummary';
export const CoachScoutingReportForm = 'CoachScoutingReportForm';
export const ViewCoachScoutingReport = 'ViewCoachScoutingReport';

export const InstructorCourseList = 'InstructorCourseList';
export const CourseDashboard = 'CourseDashboard';
export const EditCourse = 'EditCourse';
export const NewAssignment = 'NewAssignment';
export const CourseCreate = 'CourseCreate';
export const AssignmentEvaluation = 'AssignmentEvaluation';

export const StudentDashboard = 'StudentDashboard';
export const SimplePageLayout = 'SimplePageLayout';
export const StudentCoursePage = 'StudentCoursePage';
export const AssignmentSubmission = 'AssignmentSubmission';

export const EventDetails = 'EventDetails';
export const RegisterForAssessment = 'RegisterForAssessment';
export const SchoolDetails = 'SchoolDetails';